import React from 'react';
import './Agenda.css';
import VideoPresent from './VideoPresent/VideoPresent';
import Shaikh from '../../img/agenda/Shaikh.png'
import Microsoft from '../../img/agenda/Microsoft.png'
import Hahnekamp from '../../img/agenda/Hahnekamp.png'
import Angular from '../../img/agenda/Angular.png'
import Gesteira from '../../img/agenda/Gesteira.png'
import Accenture from '../../img/agenda/Accenture.png'
import Nasreddin from '../../img/agenda/Nasreddin.png'
import aws from '../../img/agenda/aws.png'


export default class Agenda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [
                {
                    time: '10:10',
                    day: 'Tuesday, Jun 25',
                    photo: Shaikh,
                    name: 'Zaki Mohammed Shaikh',
                    position: 'Consultant',
                    ln: 'https://www.linkedin.com/in/zaki-mohammed/',
                    tw: 'https://twitter.com/ZakiMohammed67',
                    github: 'https://github.com/ZakiMohammed',
                    linkAdd: 'https://calendar.google.com/calendar/u/0/r/eventedit?text=Angular+Migration+-+The+Philosophy&dates=20240625T101000Z/20240625T104000Z&details=In+this+topic,+we+will+highlight+the+challenging+problem+associated+with+Angular+migration/upgrade.+How+we+can+come+up+with+a+process+to+serve+as+a+solution+that+results+in+keeping+project+updated+and+access+of+new+features.&location=online',
                    logo: Microsoft,
                    title: 'Angular Migration - The Philosophy',
                    abstract: `In this topic, we will highlight the challenging problem associated with Angular migration/upgrade. How we can come up with a process to serve as a solution that results in keeping project updated and access of new features.`,
                },
                {
                    time: '10:40',
                    day: 'Tuesday, Jun 25',
                    photo: Hahnekamp,
                    name: 'Rainer Hahnekamp',
                    position: 'Trainer & Consultant',
                    ln: 'https://www.linkedin.com/in/rainerhahnekamp/',
                    tw: 'https://twitter.com/rainerhahnekamp',
                    github: 'https://github.com/rainerhahnekamp',
                    linkAdd: 'https://calendar.google.com/calendar/u/0/r/eventedit?text=Testing+in+Angular+in+2024&dates=20240625T104000Z/20240625T111000Z&details=As+Angular+accelerates,+so+does+the+testing+realm.+Karma+steps+aside+for+the+Web+Test+Runner,+while+Jest+gains+official+support,+and+Analog+entices+us+with+Vitest.+Playwright+claims+the+top+spot+in+E2E+before+Cypress,+leaving+us+to+ponder+the+role+of+Jasmine.+Let%27s+sort+things+out!+I%27ll+provide+a+comprehensive+overview+of+the+testing+landscape+in+2024+—+spotlighting+the+tools+that+are+now+at+our+disposal,+forecasting+future+developments,+and+outlining+what+a+contemporary+testing+strategy+entails.+Stay+ahead+with+sharp+testing+in+Angular!&location=online',
                    logo: Angular,
                    title: `Testing in Angular in 2024`,
                    abstract: `As Angular accelerates, so does the testing realm. Karma steps aside for the Web Test Runner, while Jest gains official support, and Analog entices us with Vitest. Playwright claims the top spot in E2E before Cypress, leaving us to ponder the role of Jasmine. Let's sort things out! I'll provide a comprehensive overview of the testing landscape in 2024 — spotlighting the tools that are now at our disposal, forecasting future developments, and outlining what a contemporary testing strategy entails. Stay ahead with sharp testing in Angular!`,
                },
                {
                    time: '11:10',
                    day: 'Tuesday, Jun 25',
                    photo: Gesteira,
                    name: 'Andrés Gesteira',
                    position: 'Tech Lead Angular',
                    tw: 'https://x.com/GeorgeKaplan_G',
                    linkAdd: 'https://calendar.google.com/calendar/u/0/r/eventedit?text=Class+Composition+in+Angular&dates=20240625T111000Z/20240625T114000Z&details=Join+us+for+an+in-depth+exploration+of+the+core+principles+of+TypeScript+class+composition+and+its+effortless+integration+within+the+Angular+framework.+Discover+why+this+methodology+excels+in+Angular,+fostering+adaptability+and+scalability+in+your+codebase.Learn+the+intricacies+of+implementing+class+composition+through+either+decorators+or+mixins,+and+discern+the+criteria+for+selecting+the+optimal+approach+for+your+specific+use+case.Embark+on+a+journey+through+practical+examples+crafted+for+Angular+development,+demonstrating+how+class+composition+elevates+modularity+and+sustainability,+even+extending+to+cutting-edge+Angular+features+like+Angular+signals.&location=online',
                    logo: Accenture,
                    title: `Class Composition in Angular`,
                    abstract: `Join us for an in-depth exploration of the core principles of TypeScript class composition and its effortless integration within the Angular framework. Discover why this methodology excels in Angular, fostering adaptability and scalability in your codebase.

Learn the intricacies of implementing class composition through either decorators or mixins, and discern the criteria for selecting the optimal approach for your specific use case.

Embark on a journey through practical examples crafted for Angular development, demonstrating how class composition elevates modularity and sustainability, even extending to cutting-edge Angular features like Angular signals.
`,
                },
                {
                    time: '11:40',
                    day: 'Tuesday, Jun 25',
                    name: 'Q&A SESSION',
                    title: 'Speakers: Zaki Mohammed Shaikh, Rainer Hahnekamp, Andrés Gesteira',
                },
                {
                    time: '12:10',
                    day: 'Tuesday, Jun 25',
                    photo: Nasreddin,
                    name: 'Mohammed Nasreddin',
                    position: 'Solutions Architect',
                    ln: 'https://www.linkedin.com/in/mohammed-nasreddin/',
                    linkAdd: 'https://calendar.google.com/calendar/u/0/r/eventedit?text=Clickstream+analytics+on+AWS&dates=20240625T121000Z/20240625T124000Z&details=Clickstream+analytics+on+AWS+makes+it+easy+to+collects,+ingests,+analyzes,+and+visualizes+clickstreams+from+your+websites+and+mobile+applications.+Use+this+technical+validation+deck+to+guide+the+customer+conversation+regarding+the+AWS+Solution.&location=online',
                    logo: aws,
                    title: `Clickstream analytics on AWS`,
                    abstract: `Clickstream analytics on AWS makes it easy to collects, ingests, analyzes, and visualizes clickstreams from your websites and mobile applications. Use this technical validation deck to guide the customer conversation regarding the AWS Solution.
`,
                },
            ],
        }
    }

    render() {
        return (
            <div className="agenda" id='agenda'>
                <div className='container agenda'>
                    <h2 className="agenda_title">Agenda</h2>
                    <h3 class="agenda_title">June 25 – Senior Track</h3>
                    <VideoPresent speakers={this.state.list} />
                    <a className='button agenda_full_btn' href='https://geekle.us/schedule/angular24?track=1694788536599x447138782804705300' target='_blank' rel="noreferrer">SHOW MORE</a>
                </div>
            </div>
        );
    }
};